import {CredentialType} from "@yosmanyga/base";

abstract class AuthenticationFrontendWithFacebookAbstractApi {
    abstract complete: (
        code: string,
        verifier: string
    ) => Promise<CredentialType>
}

export {
    AuthenticationFrontendWithFacebookAbstractApi
}
